<div class="header">
  <button
    [class.is-hidden]="!_canGoBack"
    [disabled]="!_canGoBack"
    (click)="_onBackButtonClick()"
    sui-icon-button
  >
    <sui-icon name="원형 이동_왼쪽"></sui-icon>
  </button>
  <span
    matTooltip="{{ this._data.bookTitle }}"
    *ngIf="_currentPage === _Page.groupSelection"
  >
    <<span class="book-title">{{ _limitBookTitle(this._data.bookTitle) }}</span
    >> 그룹책
  </span>
  <span *ngIf="_currentPage !== _Page.groupSelection">
    {{ _pageTitles[_currentPage] }}
  </span>
  <button sui-icon-button (click)="_onCloseButtonClick()">
    <sui-icon name="엑스"></sui-icon>
  </button>
</div>
<div class="divider" *ngIf="_showHeaderDivider"></div>
<div
  class="page mode-selection"
  [class.is-hidden]="_currentPage !== _Page.modeSelection"
>
  <lib-reading-mode-selection
    (modeSelected)="_onReadingModeSelected($event)"
    [bid]="_data.bid"
  ></lib-reading-mode-selection>
</div>
<div
  class="page"
  [class.group-creation]="_currentPage === _Page.groupCreation"
  *ngIf="_currentPage === _Page.groupCreation"
>
  <lib-reading-group-edit
    [bookInfo]="bookInfo"
    [contentId]="_data.bid"
    (groupCreated)="_onGroupCreated()"
  ></lib-reading-group-edit>
</div>
<div class="page" [class.is-hidden]="_currentPage !== _Page.groupSelection">
  <lib-reading-group-selection
    [contentId]="_data.bid"
    [bookInfo]="bookInfo"
    [invitedGroupId]="invitedGroupId"
    (createGroupButtonClick)="_goToPage(_Page.groupCreation)"
    (groupDetailsButtonClick)="_onGroupDetailsButtonClick($event)"
    (enterGroupButtonClick)="_onEnterGroupButtonClick($event)"
    (singleModeButtonClick)="_onSingleModeButtonClick()"
    [allowedSingleMode]="_allowedSingleMode"
  ></lib-reading-group-selection>
</div>
<div class="page group-details" *ngIf="_currentPage === _Page.groupDetails">
  <lib-reading-group-details
    *ngIf="detailsReadingGroup"
    [bookInfo]="bookInfo"
    [group]="detailsReadingGroup"
    (editGroupButtonClick)="_onEditGroupButtonClick()"
    (enterGroupButtonClick)="_onEnterGroupButtonClick($event)"
    (groupExited)="_onGroupExited()"
    (inviteGroupMemberButtonClick)="_goToPage(_Page.invitation)"
    (enterGroupButtonClick)="_onEnterGroupButtonClick($event)"
  >
  </lib-reading-group-details>
</div>
<div
  class="page"
  [class.group-edit]="_currentPage === _Page.groupEdit"
  *ngIf="_currentPage === _Page.groupEdit"
>
  <lib-reading-group-edit
    [bookInfo]="bookInfo"
    [initialValue]="detailsReadingGroup"
    (groupEdited)="_onGroupEdited()"
  ></lib-reading-group-edit>
</div>
<div class="page invite" *ngIf="_currentPage === _Page.invitation">
  <lib-reading-group-invitation
    *ngIf="detailsReadingGroup"
    [groupId]="detailsReadingGroup.id"
  ></lib-reading-group-invitation>
</div>
